



























































































import { Component, Vue } from "vue-property-decorator";
import ChatMessageBox from "@/components/chat/ChatMessageBox.vue";
import { Socket } from "vue-socket.io-extended";
import { mapGetters, mapActions } from "vuex";

@Component({
	components: {
		"chat-message-box": ChatMessageBox
	},
	computed: {
		...mapGetters("users", ["userInfo"]),
		...mapGetters("chat", ["roomid", "chats"])
	},
	methods: {
		...mapActions("chat", [
			"joinGroupChat",
			"setFetchedChats",
			"addNewChat",
			"sendChat",
			"setOnlineUsers"
		])
	}
})
export default class ChatBoard extends Vue {
	userInfo!: any;
	userChatMsg!: string;
	roomid!: string;
	chats!: [any];
	joinGroupChat!: Function;
	setFetchedChats!: Function;
	addNewChat!: Function;
	sendChat!: Function;
	setOnlineUsers!: Function;

	created() {
		this.joinGroupChat({
			username: this.userInfo.name,
			userid: this.userInfo.id,
			roomid: this.roomid
		});
	}

	@Socket()
	connect() {
		this.$socket.client.emit("joinRoom", {
			username: this.userInfo.name,
			userid: this.userInfo.id,
			roomid: this.roomid
		});
	}

	@Socket("saved_chats")
	onSavedChats(payload: [any]) {
		this.setFetchedChats(payload);
		this.scrollChatBoad();
	}

	@Socket("online_users")
	onNewOnlineUser(payload: [string]) {
		console.log("payload: ", payload);
		this.setOnlineUsers(payload);
	}

	@Socket("showChat")
	onShowChat(chatPayload: any) {
		this.addNewChat({
			message: chatPayload.message,
			user: chatPayload.user,
			date: chatPayload.date,
			avatar: chatPayload.avatar,
			reversed: chatPayload.id == this.userInfo.id
		});

		this.scrollChatBoad();
	}

	// send chat to server
	sendMessage() {
		if (
			this.userChatMsg &&
			typeof this.userChatMsg == "string" &&
			this.userChatMsg.trim().length > 0
		) {
			this.sendChat({
				roomid: this.roomid,
				message: this.userChatMsg,
				user: this.userInfo
			});
			this.scrollChatBoad();
		}
	}

	@Socket("connected")
	onConnected(message: string) {
		this.addNewChat({
			message: message,
			user: "AxumHUB",
			date: "2:20 pm",
			reversed: false
		});
		this.scrollChatBoad();
	}

	@Socket("disconnected")
	onDisconnect(message: string) {
		this.addNewChat({
			message: message,
			user: "AxumHUB",
			date: "2:20 pm",
			reversed: false
		});
		this.scrollChatBoad();
	}

	get userChatMessage() {
		return this.userChatMsg;
	}
	set userChatMessage(val) {
		this.userChatMsg = val;
	}

	scrollChatBoad() {
		this.$nextTick(() => {
			const chatMsgBoard = this.$refs.chatBoardContainer as HTMLDivElement;
			chatMsgBoard.scrollTop = chatMsgBoard.scrollHeight + 10;
		});
	}
}
